'use client';

import { Icon } from '@iconify/react';
import { Collapse } from '@mantine/core';
import Link from 'next/link';
import { useState } from 'react';
import style from './sidebar-links.module.scss';
import { usePathname, useRouter } from 'next/navigation';
import clsx from 'clsx';
import { useSidebar } from '@/context/SidebarContext';

const SidebarLinks = ({ link, level = 0, getKey, languageData }) => {
    const { toggleSidebar } = useSidebar();
    const router = useRouter();
    const pathname = usePathname();
    const [open, setOpen] = useState(false);
    const hasSublinks = link.sublinks && link.sublinks.length > 0;
    const translatedLabel = getKey(link.key, link.label, languageData?.text?.sidebar) || link.label;
    const linkIcon = <Icon icon={link.icon} fontSize="1.375rem" className={style.icon} />;
    const linkLabel = <span>{translatedLabel}</span>;
    const handleLinkClick = (event) => {
        // Keep default browser behavior (like open in new tab) intact
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        if (!link.href) return;
        event.preventDefault();
        toggleSidebar();
        router.push(link.href);
    };

    return (
        <ul className={style.sidebar_links}>
            {hasSublinks ? (
                <li>
                    <button
                        type="button"
                        onClick={() => {
                            setOpen(!open);
                        }}
                        className={style.sublink_btn}
                    >
                        {link.icon && linkIcon}
                        {link.label && linkLabel}
                        <Icon icon={open ? 'icon-park-outline:up' : 'icon-park-outline:down'} fontSize="1.375rem" className={style.dropdown_icon} />
                    </button>
                    <Collapse in={open} className={style.sublink_collapse}>
                        {link.sublinks.map((sublink, index) => (
                            <SidebarLinks key={index} link={sublink} level={level + 1} getKey={getKey}
                                languageData={languageData} />
                        ))}
                    </Collapse>
                </li>
            ) : (
                <li>
                    <Link
                        onClick={handleLinkClick}
                        href={link.href || '#'}
                        className={clsx(style.sidebar_link, pathname === link.href && style.active, pathname.startsWith(link.parentLink) && style.active)}
                        passHref
                    >
                        {link.icon && linkIcon}
                        {link.label && linkLabel}
                    </Link>
                </li>
            )}
        </ul>
    );
};

export default SidebarLinks;
